import { FilterStateValue } from '../../types/filters';

export const createRangeFromFiltersStateValue = (
  from: FilterStateValue,
  to: FilterStateValue
) => {
  return [from ? Number(from) : '', to ? Number(to) : ''];
};
